var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "g-row g-row--space_xl-xl el el--m_b_md el--m_b_none-lg" },
      _vm._l(_vm.itemsLengts, function(item) {
        return _c(
          "div",
          {
            staticClass:
              "g-cols g-cols--12 g-cols--4-mac g-cols--6-sm g-cell rel el el--m_h_xs el--m_h_2xs-xl rel"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "block_content-reviews block_content-reviews--overlay",
                class: _vm.selectedItem == item ? "active" : ""
              },
              [
                item.link_pdf
                  ? _c("a", {
                      staticClass: "icon icon--download",
                      attrs: { href: item.link_pdf, target: "_blank" }
                    })
                  : _vm._e(),
                _c("div", { staticClass: "g-row g-row--align_center" }, [
                  _c("div", { staticClass: "g-cols g-cell" }, [
                    _c("img", {
                      staticClass: "img img--testimanilas",
                      attrs: { src: item.image }
                    })
                  ]),
                  _c(
                    "div",
                    { staticClass: "g-cols g-cell el el--m_l_1xs-xl" },
                    [
                      _c("div", { staticClass: "el" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "ds-caption ds-caption--size_1sm ds-caption--size_lg-lg ds-caption--c_blue ds-caption--w_b"
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ]),
                      _c("div", { staticClass: "el el--p_t_1xs" }, [
                        _c(
                          "h3",
                          {
                            staticClass:
                              "ds-caption ds-caption--size_1xs ds-caption--size_sm-lg ds-caption--c_lgrey ds-caption--w_r"
                          },
                          [_vm._v(_vm._s(item.position))]
                        )
                      ])
                    ]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "el el--p_t_md-xl el--p_t_sm over-cards" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "ds-caption ds-caption--size_1xs ds-caption--size_1md-lg ds-caption--c_lgrey ds-caption--w_r ds-caption--h_xs ds-caption--h_lg-xl"
                      },
                      [_vm._v(_vm._s(item.description))]
                    )
                  ]
                ),
                _c("div", { staticClass: "el el--p_t_2xs el--p_t_md-lg" }, [
                  _c(
                    "div",
                    { staticClass: "g-row g-row--justify_between g-cell" },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "ds-caption ds-caption--size_xs ds-caption--c_lgrey ds-caption--w_r el el--p_b_md el--p_b_none-md"
                        },
                        [_vm._v(_vm._s(item.date))]
                      ),
                      item.lengt > _vm.numberLength && _vm.selectedItem !== item
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "ds-caption ds-caption--size_1sm ds-caption--c_lb ds-caption--w_b ds-caption--hover_line g-cols g-cols--12 g-cols g-cols--narrow-md",
                              attrs: {
                                item: item,
                                isSelected: _vm.selectedItem
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleClick(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.trans.title_btn_reviews))]
                          )
                        : _vm._e(),
                      _vm.selectedItem == item
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "ds-caption ds-caption--size_1sm ds-caption--c_lb ds-caption--w_b ds-caption--hover_line g-cols g-cols--12 g-cols g-cols--narrow-md",
                              on: {
                                click: function($event) {
                                  return _vm.handleClick(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.trans.title_btn_reviews_close))]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d9b7ef4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9b7ef4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiElements/ReadMoreReviews.vue
// module id = 98
// module chunks = 0